import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {plainToClass} from 'class-transformer';
import {SelectItem} from 'primeng/api';
import {GrowlService} from '@app/core';
import {ApprovalStatusType, BillingType, Calendar, CalendarService, Format, GrowlType, PrimeNgConfig, ProjectTask, ProjectTaskBalance, TableColumn, Validation} from '@app/shared';
import {CalendarType} from '@app/shared/enums/calendar-type.enum';
import {SolutionManagerDataService} from '@app/solution-manager/solution-manager-data.service';

@Component({
  selector: 'app-project-task-balance',
  templateUrl: './project-task-balance.component.html',
  styleUrls: ['./project-task-balance.component.css'],
  providers: [SolutionManagerDataService]
})
export class ProjectTaskBalanceComponent implements OnInit, OnChanges, AfterViewInit {

  ApprovalStatusType: typeof ApprovalStatusType = ApprovalStatusType;
  BillingType: typeof BillingType = BillingType;
  Format: typeof Format = Format;
  PrimeNgConfig = PrimeNgConfig;
  Validation: typeof Validation = Validation;

  @Input() selectedProjectTask: ProjectTask;
  @Input() displayTaskBalanceDialog: boolean;
  @Input() inSolutionManager: boolean;
  @Input() goLiveAccountingPeriodClosed: boolean;
  @Input() projectBillingType: BillingType;
  @Output() handler: EventEmitter<any> = new EventEmitter();

  tableColumns: TableColumn[];
  saveOrUpdateProjectTaskBalanceButton: boolean;
  accountingPeriodDropdown: SelectItem[];
  orgAccountingCalendarBeforeGoLive: Calendar;
  taskBalanceTable: string[] = ["employee"];
  selectedProjectTaskBalance: ProjectTaskBalance = new ProjectTaskBalance();

  constructor(private dataService: SolutionManagerDataService, private calendarService: CalendarService, private growl: GrowlService) {
  }

  ngOnInit() {
    this.getAccountingPeriodBeforeGoLive();
  }

  ngAfterViewInit() {
    this.initTableColumns();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (this.selectedProjectTask && this.selectedProjectTask.id != null) {
      this.dataService.getProjectTaskBalances(this.selectedProjectTask.id, this.inSolutionManager).subscribe(res => {
        if (res['list'].length > 0) {
          this.saveOrUpdateProjectTaskBalanceButton = false;
          this.selectedProjectTaskBalance = <ProjectTaskBalance>res['list'][0];
        } else {
          this.saveOrUpdateProjectTaskBalanceButton = true;
          this.selectedProjectTaskBalance = new ProjectTaskBalance();
          this.calendarService.getCurrentFiscalYear().subscribe(res => {
            this.selectedProjectTaskBalance.currentYear = String(res);
          });
        }
      });
    }
  }


  saveProjectTaskBalance(): void {
    this.selectedProjectTaskBalance.projectTaskId = this.selectedProjectTask.id;
    this.setCurrentYearITD(this.selectedProjectTaskBalance);
    this.dataService.saveProjectTaskBalance(this.selectedProjectTaskBalance, this.inSolutionManager).subscribe(res => {
      this.growl.add(GrowlType.Success, "Task Balance saved successfully");
      this.hideDialog();
    });
  }

  updateProjectTaskBalance(): void {
    this.setCurrentYearITD(this.selectedProjectTaskBalance);
    this.dataService.updateProjectTaskBalance(this.selectedProjectTaskBalance, this.inSolutionManager).subscribe(res => {
      this.selectedProjectTaskBalance = plainToClass(ProjectTaskBalance, res);
      this.growl.add(GrowlType.Success, "Task Balance saved successfully");

      this.hideDialog();
    });
  }


  hideDialog(): void {
    this.handler.emit('hide dialog');
  }

  cancelProjectTaskBalance(): void {
    this.hideDialog();
  }

  private getAccountingPeriodBeforeGoLive(): void {
    this.dataService.getAccountingCalendarBeforeGoLive(CalendarType.Accounting, this.inSolutionManager).subscribe(res => {
      this.orgAccountingCalendarBeforeGoLive = res;
    });
  }

  private initTableColumns(): void {
    this.tableColumns = [{header: "Field"}, {header: "Prior Year ITD"}, {header: "Current Year YTD"}, {header: "Current Year ITD"}];
  }


  private setCurrentYearITD(selectedProjectTaskBalance: ProjectTaskBalance): void {
    selectedProjectTaskBalance.currentYearEmployeeLaborITD = this.selectedProjectTaskBalance.currentYearEmployeeLaborYTD + this.selectedProjectTaskBalance.priorYearEmployeeLaborITD;
    selectedProjectTaskBalance.currentYearSubcontractorLaborITD = this.selectedProjectTaskBalance.currentYearSubcontractorLaborYTD + this.selectedProjectTaskBalance.priorYearSubcontractorLaborITD;
    selectedProjectTaskBalance.currentYearMaterialITD = this.selectedProjectTaskBalance.currentYearMaterialYTD + this.selectedProjectTaskBalance.priorYearMaterialITD;
    selectedProjectTaskBalance.currentYearOdcITD = this.selectedProjectTaskBalance.currentYearOdcYTD + this.selectedProjectTaskBalance.priorYearOdcITD;
    selectedProjectTaskBalance.currentYearLaborFringeITD = this.selectedProjectTaskBalance.currentYearLaborFringeYTD + this.selectedProjectTaskBalance.priorYearLaborFringeITD;
    selectedProjectTaskBalance.currentYearLaborOverheadITD = this.selectedProjectTaskBalance.currentYearLaborOverheadYTD + this.selectedProjectTaskBalance.priorYearLaborOverheadITD;
    selectedProjectTaskBalance.currentYearLaborMnHITD = this.selectedProjectTaskBalance.currentYearLaborMnHYTD + this.selectedProjectTaskBalance.priorYearLaborMnHITD;
    selectedProjectTaskBalance.currentYearLaborGnAITD = this.selectedProjectTaskBalance.currentYearLaborGnAYTD + this.selectedProjectTaskBalance.priorYearLaborGnAITD;
    selectedProjectTaskBalance.currentYearMaterialMnHITD = this.selectedProjectTaskBalance.currentYearMaterialMnHYTD + this.selectedProjectTaskBalance.priorYearMaterialMnHITD;
    selectedProjectTaskBalance.currentYearMaterialGnAITD = this.selectedProjectTaskBalance.currentYearMaterialGnAYTD + this.selectedProjectTaskBalance.priorYearMaterialGnAITD;
    selectedProjectTaskBalance.currentYearOdcMnHITD = this.selectedProjectTaskBalance.currentYearOdcMnHYTD + this.selectedProjectTaskBalance.priorYearOdcMnHITD;
    selectedProjectTaskBalance.currentYearOdcGnAITD = this.selectedProjectTaskBalance.currentYearOdcGnAYTD + this.selectedProjectTaskBalance.priorYearOdcGnAITD;
    selectedProjectTaskBalance.currentYearTravelITD = this.selectedProjectTaskBalance.currentYearTravelYTD + this.selectedProjectTaskBalance.priorYearTravelITD;
    selectedProjectTaskBalance.currentYearTrainingITD = this.selectedProjectTaskBalance.currentYearTrainingYTD + this.selectedProjectTaskBalance.priorYearTrainingITD;
  }

}
